import React, { useEffect, useState, createContext } from 'react';
import { useTranslation } from 'react-i18next';
import { connect, useDispatch, useSelector } from "react-redux";
import NonAuthLayout from './layouts/non-auth';
import { stringIsNullOrEmpty, isObjectEmpty } from './common/util';
import { ConfigEnum } from './common/config';
import { Language, Role } from './common/constant';
import LoadingScreen from 'components/loading-screen';
import { setBusy } from './redux/app/action';
import { WebUrl } from "./routes";
import { useLocation, useNavigate, useParams } from 'react-router-dom';

export const ToggleContent = createContext();

/// <summary>
/// Author: -
/// </summary>
const App = () => {
    const { t, i18n } = useTranslation();
    var _dispatch = useDispatch();
    var _transactionState = useSelector(state => state['transactionState']);
    const navigate = useNavigate();

    /// <summary>
    /// Author: -
    /// </summary>
    useEffect(() => {
        (async () => {
            if (stringIsNullOrEmpty(localStorage.getItem(ConfigEnum._LANGUAGE))) {
                localStorage.setItem(ConfigEnum._LANGUAGE, Language._ENGLISH);
            }
        })();
    }, []);

    /// <summary>
    /// Author: CK
    /// </summary>
    useEffect(() => {
        if (_transactionState.isCallback) {
            if (!stringIsNullOrEmpty(_transactionState.callbackUrl)) {
                const url = new URL(_transactionState.callbackUrl);

                // Check if the callback URL is your current site
                if (url.origin === window.location.origin) {
                    // Extract the path and query parameters
                    const queryParams = url.search; // e.g., "?status=success&transactionId=abc123"

                    // Navigate to the internal callback page
                    navigate(`${WebUrl._CALLBACK}${queryParams}`, { state: true, replace: true });
                } else {
                    // Redirect to the external callback URL
                    window.location.href = _transactionState.callbackUrl;
                }
            }
            else {
                navigate(`${WebUrl._CALLBACK}?errorMessage=${_transactionState.callbackMsg}`, { state: true, replace: true });
            }
        }
    }, [_transactionState.isCallback]);

    return (
        <div>
            <LoadingScreen />
            <NonAuthLayout />
        </div>
    )
}

const mapStateToProps = state => ({ ...state });

export default connect(mapStateToProps, null)(App);